import { render, staticRenderFns } from "./themeConfig.vue?vue&type=template&id=1f8a57a9"
import script from "./themeConfig.vue?vue&type=script&lang=js"
export * from "./themeConfig.vue?vue&type=script&lang=js"
import style0 from "./themeConfig.vue?vue&type=style&index=0&id=1f8a57a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports